/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '../types';

import type { FetchOptions } from "codegen/fetcher/fetcher.types"
import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { fetcher } from 'codegen/fetcher/index';
export type StudioProjectDownloadAssetsQueryVariables = Types.Exact<{
  input: Types.StudioProjectDownloadAssetsInput;
}>;


export type StudioProjectDownloadAssetsQuery = { __typename?: 'Query', studioProjectDownloadAssets: { __typename?: 'StudioProjectDownloadAssetsResponse', assets: Array<{ __typename?: 'AssetDownloadResponse', url: string, product: { __typename?: 'ContentProduct', id: string } }>, errors: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> } };

export type ContentDownloadAssetQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  source?: Types.InputMaybe<Types.ContentDownloadSource>;
}>;


export type ContentDownloadAssetQuery = { __typename?: 'Query', contentDownloadAssets: Array<{ __typename?: 'AssetDownloadResponse', url: string, product: { __typename?: 'ContentProduct', id: string }, paymentRequired?: { __typename?: 'ContentPaymentRequired', status: string, paymentUrl: string } | null }> };

export type ContentIncreaseDownloadCountMutationVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
  source?: Types.InputMaybe<Types.ContentDownloadSource>;
}>;


export type ContentIncreaseDownloadCountMutation = { __typename?: 'Mutation', contentIncreaseDownloadCount: boolean };

export type ContentLicenseCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ContentLicenseCountQuery = { __typename?: 'Query', contentLicenseCount: number };

export type ContentFavoriteProductMutationVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
}>;


export type ContentFavoriteProductMutation = { __typename?: 'Mutation', contentFavoriteProduct: boolean };

export type ContentUnfavoriteProductMutationVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
}>;


export type ContentUnfavoriteProductMutation = { __typename?: 'Mutation', contentUnfavoriteProduct: boolean };

export type ContentIsProductFavoritedQueryVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
}>;


export type ContentIsProductFavoritedQuery = { __typename?: 'Query', contentIsProductFavorited: boolean };

export type ContentCountFavoritesQueryVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
}>;


export type ContentCountFavoritesQuery = { __typename?: 'Query', contentCountFavorites: { __typename?: 'ContentProductFavoriteCount', total: number, users: Array<{ __typename?: 'PublicUserProfile', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null } | null }> } };

export type ContentTotalCountFavoritesQueryVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
}>;


export type ContentTotalCountFavoritesQuery = { __typename?: 'Query', contentCountFavorites: { __typename?: 'ContentProductFavoriteCount', total: number } };

export type ContentFetchMetadataDataQueryVariables = Types.Exact<{
  categoryId: Types.Scalars['ID']['input'];
  language: Types.ContentLanguage;
  page: Types.Scalars['Int']['input'];
  type: Types.ContentPaginationType;
}>;


export type ContentFetchMetadataDataQuery = { __typename?: 'Query', contentFetchCategory: { __typename?: 'ContentCategory', name: string, totalProducts: number, slug: string, alternativeSlugs: Array<{ __typename?: 'ContentCategorySlug', language: Types.ContentLanguage, slug: string }>, seo: { __typename?: 'ContentCategorySEO', title: string, description: string } }, contentListProducts: { __typename?: 'ContentPagination', pages: number } };

export type ContentFetchCategoryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  language: Types.ContentLanguage;
}>;


export type ContentFetchCategoryQuery = { __typename?: 'Query', contentFetchCategory: { __typename?: 'ContentCategory', id: string, parentId: string, name: string, slug: string, contentTop: string, totalProducts: number, root?: { __typename?: 'ContentCategory', id: string } | null } };

export type ContentListProductsQueryVariables = Types.Exact<{
  categoryId: Types.Scalars['ID']['input'];
  page: Types.Scalars['Int']['input'];
  type: Types.ContentPaginationType;
  language: Types.ContentLanguage;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ContentListProductsQuery = { __typename?: 'Query', contentListProducts: { __typename?: 'ContentPagination', categoryId: string, currentPage: number, type: Types.ContentPaginationType, pages: number, limit: number, products: Array<{ __typename?: 'ContentProduct', title: string, slug: string, id: string, author_id: string, publicAssets: Array<{ __typename?: 'ContentAsset', type: Types.ContentAssetType, variant: Types.ContentAssetVariant, file_path: string, resolution?: { __typename?: 'ContentAssetResolution', width: number, height: number } | null }> }> } };

export type ContentLinkBlockQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  language: Types.ContentLanguage;
}>;


export type ContentLinkBlockQuery = { __typename?: 'Query', contentLinkBlock?: { __typename?: 'ContentLinkBlock', id: string, title: string, links: Array<{ __typename?: 'ContentLinkBlockLink', anchor: string, url: string }> } | null };

export type ContentSearchCategoryQueryVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
  parentId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  language: Types.ContentLanguage;
}>;


export type ContentSearchCategoryQuery = { __typename?: 'Query', contentSearchCategory: Array<{ __typename?: 'ContentCategory', id: string, name: string, slug: string }> };

export type ContentListProductsV2QueryVariables = Types.Exact<{
  categoryId: Types.Scalars['ID']['input'];
  page: Types.Scalars['Int']['input'];
  type: Types.ContentPaginationType;
  language: Types.ContentLanguage;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ContentListProductsV2Query = { __typename?: 'Query', contentListProductsV2: { __typename?: 'ContentPaginationV2', categoryId: string, currentPage: number, type: Types.ContentPaginationType, pages: number, products: Array<{ __typename?: 'ContentProductPreview', title: string, slug: string, id: string, authorId: string, previewPath: string, previewWidth: number, previewHeight: number }> } };

export type ContentFetchProductQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  language: Types.ContentLanguage;
}>;


export type ContentFetchProductQuery = { __typename?: 'Query', contentProduct?: { __typename?: 'ContentProduct', id: string, title: string, slug: string, description: string, views_count: number, downloads_count: number, created_at: any, tags?: Array<string> | null, status: Types.ContentProductStatus, licenses: Array<{ __typename?: 'ContentLicense', key: string, createdAt: any }>, category: { __typename?: 'ContentCategory', id: string, name: string, slug: string, root?: { __typename?: 'ContentCategory', id: string, name: string, slug: string, totalProducts: number } | null }, linkBlocks: Array<{ __typename?: 'ContentLinkBlock', id: string, title: string, links: Array<{ __typename?: 'ContentLinkBlockLink', anchor: string, url: string }> }>, assets: Array<{ __typename?: 'ContentAsset', id: string, downloadable: boolean, type: Types.ContentAssetType, variant: Types.ContentAssetVariant, file_path: string, size_bytes: number, resolution?: { __typename?: 'ContentAssetResolution', width: number, height: number } | null }>, publicAssets: Array<{ __typename?: 'ContentAsset', type: Types.ContentAssetType, variant: Types.ContentAssetVariant, file_path: string, resolution?: { __typename?: 'ContentAssetResolution', width: number, height: number } | null }>, alternativeSlugs?: Array<{ __typename?: 'ContentAlternativeSlug', language: Types.ContentLanguage, slug: string }> | null } | null };

export type ContentProductIncreaseViewCountQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  locale: Types.ContentLanguage;
  increaseViewCount?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ContentProductIncreaseViewCountQuery = { __typename?: 'Query', contentProduct?: { __typename?: 'ContentProduct', id: string } | null };

export type ContentFetchLicenseQueryVariables = Types.Exact<{
  input: Types.ContentFetchLicenseInput;
}>;


export type ContentFetchLicenseQuery = { __typename?: 'Query', contentFetchLicense?: { __typename?: 'ContentLicense', key: string } | null };

export type ContentFetchReviewsQueryVariables = Types.Exact<{
  input: Types.ContentProductReviewsInput;
}>;


export type ContentFetchReviewsQuery = { __typename?: 'Query', contentProductReviews: { __typename?: 'ContentProductReviews', cursor: string, rating: { __typename?: 'ContentReviewRating', average: number, count: number, groups: Array<{ __typename?: 'ContentReviewRatingGroup', rating: number, count: number }> }, reviews: Array<{ __typename?: 'ContentReview', id: string, parentId?: string | null, userId: string, rating?: number | null, body: string, createdAt: any, user: { __typename?: 'PublicUserProfile', id: string, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null } | null } }> } };

export type ContentCreateReviewMutationVariables = Types.Exact<{
  productId: Types.Scalars['String']['input'];
  parentId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  rating?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  body: Types.Scalars['String']['input'];
  getInTouch?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ContentCreateReviewMutation = { __typename?: 'Mutation', contentCreateReview: boolean };

export type ContentEditReviewMutationVariables = Types.Exact<{
  reviewId: Types.Scalars['ID']['input'];
  rating?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  body: Types.Scalars['String']['input'];
}>;


export type ContentEditReviewMutation = { __typename?: 'Mutation', contentEditReview: boolean };

export type ContentMyReviewQueryVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
}>;


export type ContentMyReviewQuery = { __typename?: 'Query', contentMyReview?: { __typename?: 'ContentReview', id: string, rating?: number | null, body: string, createdAt: any } | null };

export type ContentProductStatsQueryVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
}>;


export type ContentProductStatsQuery = { __typename?: 'Query', contentProductStats: { __typename?: 'ContentProductStats', downloads: number, views: number, favorites: number } };


export const StudioProjectDownloadAssetsDocument = /*#__PURE__*/ `
    query StudioProjectDownloadAssets($input: StudioProjectDownloadAssetsInput!) {
  studioProjectDownloadAssets(input: $input) {
    assets {
      url
      product {
        id
      }
    }
    errors {
      code
      message
    }
  }
}
    `;
export const useStudioProjectDownloadAssetsQuery = <
      TData = StudioProjectDownloadAssetsQuery,
      TError = unknown
    >(
      variables: StudioProjectDownloadAssetsQueryVariables,
      options?: UseQueryOptions<StudioProjectDownloadAssetsQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<StudioProjectDownloadAssetsQuery, TError, TData>(
      ['StudioProjectDownloadAssets', variables],
      fetcher<StudioProjectDownloadAssetsQuery, StudioProjectDownloadAssetsQueryVariables>(StudioProjectDownloadAssetsDocument, variables, headers, fetchOptions),
      options,
    );
useStudioProjectDownloadAssetsQuery.document = StudioProjectDownloadAssetsDocument;


useStudioProjectDownloadAssetsQuery.getKey = (variables: StudioProjectDownloadAssetsQueryVariables) => ['StudioProjectDownloadAssets', variables];
;


useStudioProjectDownloadAssetsQuery.rootKey = 'StudioProjectDownloadAssets';

export const useInfiniteStudioProjectDownloadAssetsQuery = <
      TData = StudioProjectDownloadAssetsQuery,
      TError = unknown
    >(
      variables: StudioProjectDownloadAssetsQueryVariables,
      options?: UseInfiniteQueryOptions<StudioProjectDownloadAssetsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<StudioProjectDownloadAssetsQuery, TError, TData>(
      ['StudioProjectDownloadAssets.infinite', variables],
      (metaData) => fetcher<StudioProjectDownloadAssetsQuery, StudioProjectDownloadAssetsQueryVariables>(StudioProjectDownloadAssetsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteStudioProjectDownloadAssetsQuery.getKey = (variables: StudioProjectDownloadAssetsQueryVariables) => ['StudioProjectDownloadAssets.infinite', variables];
;


useInfiniteStudioProjectDownloadAssetsQuery.rootKey = 'StudioProjectDownloadAssets.infinite';

useStudioProjectDownloadAssetsQuery.fetcher = (variables: StudioProjectDownloadAssetsQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<StudioProjectDownloadAssetsQuery, StudioProjectDownloadAssetsQueryVariables>(StudioProjectDownloadAssetsDocument, variables, headers, fetchOptions);
export const ContentDownloadAssetDocument = /*#__PURE__*/ `
    query contentDownloadAsset($ids: [ID!]!, $source: ContentDownloadSource) {
  contentDownloadAssets(ids: $ids, source: $source) {
    url
    product {
      id
    }
    paymentRequired {
      status
      paymentUrl
    }
  }
}
    `;
export const useContentDownloadAssetQuery = <
      TData = ContentDownloadAssetQuery,
      TError = unknown
    >(
      variables: ContentDownloadAssetQueryVariables,
      options?: UseQueryOptions<ContentDownloadAssetQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentDownloadAssetQuery, TError, TData>(
      ['contentDownloadAsset', variables],
      fetcher<ContentDownloadAssetQuery, ContentDownloadAssetQueryVariables>(ContentDownloadAssetDocument, variables, headers, fetchOptions),
      options,
    );
useContentDownloadAssetQuery.document = ContentDownloadAssetDocument;


useContentDownloadAssetQuery.getKey = (variables: ContentDownloadAssetQueryVariables) => ['contentDownloadAsset', variables];
;


useContentDownloadAssetQuery.rootKey = 'contentDownloadAsset';

export const useInfiniteContentDownloadAssetQuery = <
      TData = ContentDownloadAssetQuery,
      TError = unknown
    >(
      variables: ContentDownloadAssetQueryVariables,
      options?: UseInfiniteQueryOptions<ContentDownloadAssetQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentDownloadAssetQuery, TError, TData>(
      ['contentDownloadAsset.infinite', variables],
      (metaData) => fetcher<ContentDownloadAssetQuery, ContentDownloadAssetQueryVariables>(ContentDownloadAssetDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentDownloadAssetQuery.getKey = (variables: ContentDownloadAssetQueryVariables) => ['contentDownloadAsset.infinite', variables];
;


useInfiniteContentDownloadAssetQuery.rootKey = 'contentDownloadAsset.infinite';

useContentDownloadAssetQuery.fetcher = (variables: ContentDownloadAssetQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentDownloadAssetQuery, ContentDownloadAssetQueryVariables>(ContentDownloadAssetDocument, variables, headers, fetchOptions);
export const ContentIncreaseDownloadCountDocument = /*#__PURE__*/ `
    mutation contentIncreaseDownloadCount($productId: ID!, $source: ContentDownloadSource) {
  contentIncreaseDownloadCount(productId: $productId, source: $source)
}
    `;
export const useContentIncreaseDownloadCountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ContentIncreaseDownloadCountMutation, TError, ContentIncreaseDownloadCountMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) =>
    useMutation<ContentIncreaseDownloadCountMutation, TError, ContentIncreaseDownloadCountMutationVariables, TContext>(
      ['contentIncreaseDownloadCount'],
      (variables?: ContentIncreaseDownloadCountMutationVariables) => fetcher<ContentIncreaseDownloadCountMutation, ContentIncreaseDownloadCountMutationVariables>(ContentIncreaseDownloadCountDocument, variables, headers, fetchOptions)(),
      options
    );
useContentIncreaseDownloadCountMutation.getKey = () => ['contentIncreaseDownloadCount'];

useContentIncreaseDownloadCountMutation.fetcher = (variables: ContentIncreaseDownloadCountMutationVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentIncreaseDownloadCountMutation, ContentIncreaseDownloadCountMutationVariables>(ContentIncreaseDownloadCountDocument, variables, headers, fetchOptions);
export const ContentLicenseCountDocument = /*#__PURE__*/ `
    query contentLicenseCount {
  contentLicenseCount
}
    `;
export const useContentLicenseCountQuery = <
      TData = ContentLicenseCountQuery,
      TError = unknown
    >(
      variables?: ContentLicenseCountQueryVariables,
      options?: UseQueryOptions<ContentLicenseCountQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentLicenseCountQuery, TError, TData>(
      variables === undefined ? ['contentLicenseCount'] : ['contentLicenseCount', variables],
      fetcher<ContentLicenseCountQuery, ContentLicenseCountQueryVariables>(ContentLicenseCountDocument, variables, headers, fetchOptions),
      options,
    );
useContentLicenseCountQuery.document = ContentLicenseCountDocument;


useContentLicenseCountQuery.getKey = (variables?: ContentLicenseCountQueryVariables) => variables === undefined ? ['contentLicenseCount'] : ['contentLicenseCount', variables];
;


useContentLicenseCountQuery.rootKey = 'contentLicenseCount';

export const useInfiniteContentLicenseCountQuery = <
      TData = ContentLicenseCountQuery,
      TError = unknown
    >(
      variables?: ContentLicenseCountQueryVariables,
      options?: UseInfiniteQueryOptions<ContentLicenseCountQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentLicenseCountQuery, TError, TData>(
      variables === undefined ? ['contentLicenseCount.infinite'] : ['contentLicenseCount.infinite', variables],
      (metaData) => fetcher<ContentLicenseCountQuery, ContentLicenseCountQueryVariables>(ContentLicenseCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentLicenseCountQuery.getKey = (variables?: ContentLicenseCountQueryVariables) => variables === undefined ? ['contentLicenseCount.infinite'] : ['contentLicenseCount.infinite', variables];
;


useInfiniteContentLicenseCountQuery.rootKey = 'contentLicenseCount.infinite';

useContentLicenseCountQuery.fetcher = (variables?: ContentLicenseCountQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentLicenseCountQuery, ContentLicenseCountQueryVariables>(ContentLicenseCountDocument, variables, headers, fetchOptions);
export const ContentFavoriteProductDocument = /*#__PURE__*/ `
    mutation contentFavoriteProduct($productId: ID!) {
  contentFavoriteProduct(productId: $productId)
}
    `;
export const useContentFavoriteProductMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ContentFavoriteProductMutation, TError, ContentFavoriteProductMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) =>
    useMutation<ContentFavoriteProductMutation, TError, ContentFavoriteProductMutationVariables, TContext>(
      ['contentFavoriteProduct'],
      (variables?: ContentFavoriteProductMutationVariables) => fetcher<ContentFavoriteProductMutation, ContentFavoriteProductMutationVariables>(ContentFavoriteProductDocument, variables, headers, fetchOptions)(),
      options
    );
useContentFavoriteProductMutation.getKey = () => ['contentFavoriteProduct'];

useContentFavoriteProductMutation.fetcher = (variables: ContentFavoriteProductMutationVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentFavoriteProductMutation, ContentFavoriteProductMutationVariables>(ContentFavoriteProductDocument, variables, headers, fetchOptions);
export const ContentUnfavoriteProductDocument = /*#__PURE__*/ `
    mutation contentUnfavoriteProduct($productId: ID!) {
  contentUnfavoriteProduct(productId: $productId)
}
    `;
export const useContentUnfavoriteProductMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ContentUnfavoriteProductMutation, TError, ContentUnfavoriteProductMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) =>
    useMutation<ContentUnfavoriteProductMutation, TError, ContentUnfavoriteProductMutationVariables, TContext>(
      ['contentUnfavoriteProduct'],
      (variables?: ContentUnfavoriteProductMutationVariables) => fetcher<ContentUnfavoriteProductMutation, ContentUnfavoriteProductMutationVariables>(ContentUnfavoriteProductDocument, variables, headers, fetchOptions)(),
      options
    );
useContentUnfavoriteProductMutation.getKey = () => ['contentUnfavoriteProduct'];

useContentUnfavoriteProductMutation.fetcher = (variables: ContentUnfavoriteProductMutationVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentUnfavoriteProductMutation, ContentUnfavoriteProductMutationVariables>(ContentUnfavoriteProductDocument, variables, headers, fetchOptions);
export const ContentIsProductFavoritedDocument = /*#__PURE__*/ `
    query ContentIsProductFavorited($productId: ID!) {
  contentIsProductFavorited(productId: $productId)
}
    `;
export const useContentIsProductFavoritedQuery = <
      TData = ContentIsProductFavoritedQuery,
      TError = unknown
    >(
      variables: ContentIsProductFavoritedQueryVariables,
      options?: UseQueryOptions<ContentIsProductFavoritedQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentIsProductFavoritedQuery, TError, TData>(
      ['ContentIsProductFavorited', variables],
      fetcher<ContentIsProductFavoritedQuery, ContentIsProductFavoritedQueryVariables>(ContentIsProductFavoritedDocument, variables, headers, fetchOptions),
      options,
    );
useContentIsProductFavoritedQuery.document = ContentIsProductFavoritedDocument;


useContentIsProductFavoritedQuery.getKey = (variables: ContentIsProductFavoritedQueryVariables) => ['ContentIsProductFavorited', variables];
;


useContentIsProductFavoritedQuery.rootKey = 'ContentIsProductFavorited';

export const useInfiniteContentIsProductFavoritedQuery = <
      TData = ContentIsProductFavoritedQuery,
      TError = unknown
    >(
      variables: ContentIsProductFavoritedQueryVariables,
      options?: UseInfiniteQueryOptions<ContentIsProductFavoritedQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentIsProductFavoritedQuery, TError, TData>(
      ['ContentIsProductFavorited.infinite', variables],
      (metaData) => fetcher<ContentIsProductFavoritedQuery, ContentIsProductFavoritedQueryVariables>(ContentIsProductFavoritedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentIsProductFavoritedQuery.getKey = (variables: ContentIsProductFavoritedQueryVariables) => ['ContentIsProductFavorited.infinite', variables];
;


useInfiniteContentIsProductFavoritedQuery.rootKey = 'ContentIsProductFavorited.infinite';

useContentIsProductFavoritedQuery.fetcher = (variables: ContentIsProductFavoritedQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentIsProductFavoritedQuery, ContentIsProductFavoritedQueryVariables>(ContentIsProductFavoritedDocument, variables, headers, fetchOptions);
export const ContentCountFavoritesDocument = /*#__PURE__*/ `
    query ContentCountFavorites($productId: ID!) {
  contentCountFavorites(productId: $productId) {
    total
    users {
      firstName
      lastName
      profileUrls {
        crafter
      }
      avatarUrl
    }
  }
}
    `;
export const useContentCountFavoritesQuery = <
      TData = ContentCountFavoritesQuery,
      TError = unknown
    >(
      variables: ContentCountFavoritesQueryVariables,
      options?: UseQueryOptions<ContentCountFavoritesQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentCountFavoritesQuery, TError, TData>(
      ['ContentCountFavorites', variables],
      fetcher<ContentCountFavoritesQuery, ContentCountFavoritesQueryVariables>(ContentCountFavoritesDocument, variables, headers, fetchOptions),
      options,
    );
useContentCountFavoritesQuery.document = ContentCountFavoritesDocument;


useContentCountFavoritesQuery.getKey = (variables: ContentCountFavoritesQueryVariables) => ['ContentCountFavorites', variables];
;


useContentCountFavoritesQuery.rootKey = 'ContentCountFavorites';

export const useInfiniteContentCountFavoritesQuery = <
      TData = ContentCountFavoritesQuery,
      TError = unknown
    >(
      variables: ContentCountFavoritesQueryVariables,
      options?: UseInfiniteQueryOptions<ContentCountFavoritesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentCountFavoritesQuery, TError, TData>(
      ['ContentCountFavorites.infinite', variables],
      (metaData) => fetcher<ContentCountFavoritesQuery, ContentCountFavoritesQueryVariables>(ContentCountFavoritesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentCountFavoritesQuery.getKey = (variables: ContentCountFavoritesQueryVariables) => ['ContentCountFavorites.infinite', variables];
;


useInfiniteContentCountFavoritesQuery.rootKey = 'ContentCountFavorites.infinite';

useContentCountFavoritesQuery.fetcher = (variables: ContentCountFavoritesQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentCountFavoritesQuery, ContentCountFavoritesQueryVariables>(ContentCountFavoritesDocument, variables, headers, fetchOptions);
export const ContentTotalCountFavoritesDocument = /*#__PURE__*/ `
    query ContentTotalCountFavorites($productId: ID!) {
  contentCountFavorites(productId: $productId) {
    total
  }
}
    `;
export const useContentTotalCountFavoritesQuery = <
      TData = ContentTotalCountFavoritesQuery,
      TError = unknown
    >(
      variables: ContentTotalCountFavoritesQueryVariables,
      options?: UseQueryOptions<ContentTotalCountFavoritesQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentTotalCountFavoritesQuery, TError, TData>(
      ['ContentTotalCountFavorites', variables],
      fetcher<ContentTotalCountFavoritesQuery, ContentTotalCountFavoritesQueryVariables>(ContentTotalCountFavoritesDocument, variables, headers, fetchOptions),
      options,
    );
useContentTotalCountFavoritesQuery.document = ContentTotalCountFavoritesDocument;


useContentTotalCountFavoritesQuery.getKey = (variables: ContentTotalCountFavoritesQueryVariables) => ['ContentTotalCountFavorites', variables];
;


useContentTotalCountFavoritesQuery.rootKey = 'ContentTotalCountFavorites';

export const useInfiniteContentTotalCountFavoritesQuery = <
      TData = ContentTotalCountFavoritesQuery,
      TError = unknown
    >(
      variables: ContentTotalCountFavoritesQueryVariables,
      options?: UseInfiniteQueryOptions<ContentTotalCountFavoritesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentTotalCountFavoritesQuery, TError, TData>(
      ['ContentTotalCountFavorites.infinite', variables],
      (metaData) => fetcher<ContentTotalCountFavoritesQuery, ContentTotalCountFavoritesQueryVariables>(ContentTotalCountFavoritesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentTotalCountFavoritesQuery.getKey = (variables: ContentTotalCountFavoritesQueryVariables) => ['ContentTotalCountFavorites.infinite', variables];
;


useInfiniteContentTotalCountFavoritesQuery.rootKey = 'ContentTotalCountFavorites.infinite';

useContentTotalCountFavoritesQuery.fetcher = (variables: ContentTotalCountFavoritesQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentTotalCountFavoritesQuery, ContentTotalCountFavoritesQueryVariables>(ContentTotalCountFavoritesDocument, variables, headers, fetchOptions);
export const ContentFetchMetadataDataDocument = /*#__PURE__*/ `
    query contentFetchMetadataData($categoryId: ID!, $language: ContentLanguage!, $page: Int!, $type: ContentPaginationType!) {
  contentFetchCategory(id: $categoryId, language: $language) {
    name
    totalProducts
    slug
    alternativeSlugs {
      language
      slug
    }
    seo {
      title
      description
    }
  }
  contentListProducts(
    categoryId: $categoryId
    language: $language
    page: $page
    type: $type
  ) {
    pages
  }
}
    `;
export const useContentFetchMetadataDataQuery = <
      TData = ContentFetchMetadataDataQuery,
      TError = unknown
    >(
      variables: ContentFetchMetadataDataQueryVariables,
      options?: UseQueryOptions<ContentFetchMetadataDataQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentFetchMetadataDataQuery, TError, TData>(
      ['contentFetchMetadataData', variables],
      fetcher<ContentFetchMetadataDataQuery, ContentFetchMetadataDataQueryVariables>(ContentFetchMetadataDataDocument, variables, headers, fetchOptions),
      options,
    );
useContentFetchMetadataDataQuery.document = ContentFetchMetadataDataDocument;


useContentFetchMetadataDataQuery.getKey = (variables: ContentFetchMetadataDataQueryVariables) => ['contentFetchMetadataData', variables];
;


useContentFetchMetadataDataQuery.rootKey = 'contentFetchMetadataData';

export const useInfiniteContentFetchMetadataDataQuery = <
      TData = ContentFetchMetadataDataQuery,
      TError = unknown
    >(
      variables: ContentFetchMetadataDataQueryVariables,
      options?: UseInfiniteQueryOptions<ContentFetchMetadataDataQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentFetchMetadataDataQuery, TError, TData>(
      ['contentFetchMetadataData.infinite', variables],
      (metaData) => fetcher<ContentFetchMetadataDataQuery, ContentFetchMetadataDataQueryVariables>(ContentFetchMetadataDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentFetchMetadataDataQuery.getKey = (variables: ContentFetchMetadataDataQueryVariables) => ['contentFetchMetadataData.infinite', variables];
;


useInfiniteContentFetchMetadataDataQuery.rootKey = 'contentFetchMetadataData.infinite';

useContentFetchMetadataDataQuery.fetcher = (variables: ContentFetchMetadataDataQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentFetchMetadataDataQuery, ContentFetchMetadataDataQueryVariables>(ContentFetchMetadataDataDocument, variables, headers, fetchOptions);
export const ContentFetchCategoryDocument = /*#__PURE__*/ `
    query contentFetchCategory($id: ID!, $language: ContentLanguage!) {
  contentFetchCategory(id: $id, language: $language) {
    id
    parentId
    name
    slug
    contentTop
    totalProducts
    root {
      id
    }
  }
}
    `;
export const useContentFetchCategoryQuery = <
      TData = ContentFetchCategoryQuery,
      TError = unknown
    >(
      variables: ContentFetchCategoryQueryVariables,
      options?: UseQueryOptions<ContentFetchCategoryQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentFetchCategoryQuery, TError, TData>(
      ['contentFetchCategory', variables],
      fetcher<ContentFetchCategoryQuery, ContentFetchCategoryQueryVariables>(ContentFetchCategoryDocument, variables, headers, fetchOptions),
      options,
    );
useContentFetchCategoryQuery.document = ContentFetchCategoryDocument;


useContentFetchCategoryQuery.getKey = (variables: ContentFetchCategoryQueryVariables) => ['contentFetchCategory', variables];
;


useContentFetchCategoryQuery.rootKey = 'contentFetchCategory';

export const useInfiniteContentFetchCategoryQuery = <
      TData = ContentFetchCategoryQuery,
      TError = unknown
    >(
      variables: ContentFetchCategoryQueryVariables,
      options?: UseInfiniteQueryOptions<ContentFetchCategoryQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentFetchCategoryQuery, TError, TData>(
      ['contentFetchCategory.infinite', variables],
      (metaData) => fetcher<ContentFetchCategoryQuery, ContentFetchCategoryQueryVariables>(ContentFetchCategoryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentFetchCategoryQuery.getKey = (variables: ContentFetchCategoryQueryVariables) => ['contentFetchCategory.infinite', variables];
;


useInfiniteContentFetchCategoryQuery.rootKey = 'contentFetchCategory.infinite';

useContentFetchCategoryQuery.fetcher = (variables: ContentFetchCategoryQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentFetchCategoryQuery, ContentFetchCategoryQueryVariables>(ContentFetchCategoryDocument, variables, headers, fetchOptions);
export const ContentListProductsDocument = /*#__PURE__*/ `
    query contentListProducts($categoryId: ID!, $page: Int!, $type: ContentPaginationType!, $language: ContentLanguage!, $limit: Int) {
  contentListProducts(
    categoryId: $categoryId
    page: $page
    type: $type
    language: $language
    limit: $limit
  ) {
    categoryId
    currentPage
    type
    pages
    limit
    products {
      title
      slug
      id
      author_id
      publicAssets {
        type
        variant
        file_path
        resolution {
          width
          height
        }
      }
    }
  }
}
    `;
export const useContentListProductsQuery = <
      TData = ContentListProductsQuery,
      TError = unknown
    >(
      variables: ContentListProductsQueryVariables,
      options?: UseQueryOptions<ContentListProductsQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentListProductsQuery, TError, TData>(
      ['contentListProducts', variables],
      fetcher<ContentListProductsQuery, ContentListProductsQueryVariables>(ContentListProductsDocument, variables, headers, fetchOptions),
      options,
    );
useContentListProductsQuery.document = ContentListProductsDocument;


useContentListProductsQuery.getKey = (variables: ContentListProductsQueryVariables) => ['contentListProducts', variables];
;


useContentListProductsQuery.rootKey = 'contentListProducts';

export const useInfiniteContentListProductsQuery = <
      TData = ContentListProductsQuery,
      TError = unknown
    >(
      variables: ContentListProductsQueryVariables,
      options?: UseInfiniteQueryOptions<ContentListProductsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentListProductsQuery, TError, TData>(
      ['contentListProducts.infinite', variables],
      (metaData) => fetcher<ContentListProductsQuery, ContentListProductsQueryVariables>(ContentListProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentListProductsQuery.getKey = (variables: ContentListProductsQueryVariables) => ['contentListProducts.infinite', variables];
;


useInfiniteContentListProductsQuery.rootKey = 'contentListProducts.infinite';

useContentListProductsQuery.fetcher = (variables: ContentListProductsQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentListProductsQuery, ContentListProductsQueryVariables>(ContentListProductsDocument, variables, headers, fetchOptions);
export const ContentLinkBlockDocument = /*#__PURE__*/ `
    query contentLinkBlock($id: ID!, $language: ContentLanguage!) {
  contentLinkBlock(id: $id, language: $language) {
    id
    title
    links {
      anchor
      url
    }
  }
}
    `;
export const useContentLinkBlockQuery = <
      TData = ContentLinkBlockQuery,
      TError = unknown
    >(
      variables: ContentLinkBlockQueryVariables,
      options?: UseQueryOptions<ContentLinkBlockQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentLinkBlockQuery, TError, TData>(
      ['contentLinkBlock', variables],
      fetcher<ContentLinkBlockQuery, ContentLinkBlockQueryVariables>(ContentLinkBlockDocument, variables, headers, fetchOptions),
      options,
    );
useContentLinkBlockQuery.document = ContentLinkBlockDocument;


useContentLinkBlockQuery.getKey = (variables: ContentLinkBlockQueryVariables) => ['contentLinkBlock', variables];
;


useContentLinkBlockQuery.rootKey = 'contentLinkBlock';

export const useInfiniteContentLinkBlockQuery = <
      TData = ContentLinkBlockQuery,
      TError = unknown
    >(
      variables: ContentLinkBlockQueryVariables,
      options?: UseInfiniteQueryOptions<ContentLinkBlockQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentLinkBlockQuery, TError, TData>(
      ['contentLinkBlock.infinite', variables],
      (metaData) => fetcher<ContentLinkBlockQuery, ContentLinkBlockQueryVariables>(ContentLinkBlockDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentLinkBlockQuery.getKey = (variables: ContentLinkBlockQueryVariables) => ['contentLinkBlock.infinite', variables];
;


useInfiniteContentLinkBlockQuery.rootKey = 'contentLinkBlock.infinite';

useContentLinkBlockQuery.fetcher = (variables: ContentLinkBlockQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentLinkBlockQuery, ContentLinkBlockQueryVariables>(ContentLinkBlockDocument, variables, headers, fetchOptions);
export const ContentSearchCategoryDocument = /*#__PURE__*/ `
    query contentSearchCategory($name: String!, $parentId: String, $language: ContentLanguage!) {
  contentSearchCategory(name: $name, parentId: $parentId, language: $language) {
    id
    name
    slug
  }
}
    `;
export const useContentSearchCategoryQuery = <
      TData = ContentSearchCategoryQuery,
      TError = unknown
    >(
      variables: ContentSearchCategoryQueryVariables,
      options?: UseQueryOptions<ContentSearchCategoryQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentSearchCategoryQuery, TError, TData>(
      ['contentSearchCategory', variables],
      fetcher<ContentSearchCategoryQuery, ContentSearchCategoryQueryVariables>(ContentSearchCategoryDocument, variables, headers, fetchOptions),
      options,
    );
useContentSearchCategoryQuery.document = ContentSearchCategoryDocument;


useContentSearchCategoryQuery.getKey = (variables: ContentSearchCategoryQueryVariables) => ['contentSearchCategory', variables];
;


useContentSearchCategoryQuery.rootKey = 'contentSearchCategory';

export const useInfiniteContentSearchCategoryQuery = <
      TData = ContentSearchCategoryQuery,
      TError = unknown
    >(
      variables: ContentSearchCategoryQueryVariables,
      options?: UseInfiniteQueryOptions<ContentSearchCategoryQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentSearchCategoryQuery, TError, TData>(
      ['contentSearchCategory.infinite', variables],
      (metaData) => fetcher<ContentSearchCategoryQuery, ContentSearchCategoryQueryVariables>(ContentSearchCategoryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentSearchCategoryQuery.getKey = (variables: ContentSearchCategoryQueryVariables) => ['contentSearchCategory.infinite', variables];
;


useInfiniteContentSearchCategoryQuery.rootKey = 'contentSearchCategory.infinite';

useContentSearchCategoryQuery.fetcher = (variables: ContentSearchCategoryQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentSearchCategoryQuery, ContentSearchCategoryQueryVariables>(ContentSearchCategoryDocument, variables, headers, fetchOptions);
export const ContentListProductsV2Document = /*#__PURE__*/ `
    query contentListProductsV2($categoryId: ID!, $page: Int!, $type: ContentPaginationType!, $language: ContentLanguage!, $limit: Int) {
  contentListProductsV2(
    categoryId: $categoryId
    page: $page
    type: $type
    language: $language
    limit: $limit
  ) {
    categoryId
    currentPage
    type
    pages
    products {
      title
      slug
      id
      authorId
      previewPath
      previewWidth
      previewHeight
    }
  }
}
    `;
export const useContentListProductsV2Query = <
      TData = ContentListProductsV2Query,
      TError = unknown
    >(
      variables: ContentListProductsV2QueryVariables,
      options?: UseQueryOptions<ContentListProductsV2Query, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentListProductsV2Query, TError, TData>(
      ['contentListProductsV2', variables],
      fetcher<ContentListProductsV2Query, ContentListProductsV2QueryVariables>(ContentListProductsV2Document, variables, headers, fetchOptions),
      options,
    );
useContentListProductsV2Query.document = ContentListProductsV2Document;


useContentListProductsV2Query.getKey = (variables: ContentListProductsV2QueryVariables) => ['contentListProductsV2', variables];
;


useContentListProductsV2Query.rootKey = 'contentListProductsV2';

export const useInfiniteContentListProductsV2Query = <
      TData = ContentListProductsV2Query,
      TError = unknown
    >(
      variables: ContentListProductsV2QueryVariables,
      options?: UseInfiniteQueryOptions<ContentListProductsV2Query, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentListProductsV2Query, TError, TData>(
      ['contentListProductsV2.infinite', variables],
      (metaData) => fetcher<ContentListProductsV2Query, ContentListProductsV2QueryVariables>(ContentListProductsV2Document, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentListProductsV2Query.getKey = (variables: ContentListProductsV2QueryVariables) => ['contentListProductsV2.infinite', variables];
;


useInfiniteContentListProductsV2Query.rootKey = 'contentListProductsV2.infinite';

useContentListProductsV2Query.fetcher = (variables: ContentListProductsV2QueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentListProductsV2Query, ContentListProductsV2QueryVariables>(ContentListProductsV2Document, variables, headers, fetchOptions);
export const ContentFetchProductDocument = /*#__PURE__*/ `
    query contentFetchProduct($id: ID!, $language: ContentLanguage!) {
  contentProduct(id: $id, language: $language) {
    id
    title
    slug
    description
    views_count
    downloads_count
    created_at
    tags
    status
    licenses {
      key
      createdAt
    }
    category {
      id
      name
      slug
      root {
        id
        name
        slug
        totalProducts
      }
    }
    linkBlocks {
      id
      title
      links {
        anchor
        url
      }
    }
    assets {
      id
      downloadable
      type
      variant
      file_path
      size_bytes
      resolution {
        width
        height
      }
    }
    publicAssets {
      type
      variant
      file_path
      resolution {
        width
        height
      }
    }
    alternativeSlugs {
      language
      slug
    }
  }
}
    `;
export const useContentFetchProductQuery = <
      TData = ContentFetchProductQuery,
      TError = unknown
    >(
      variables: ContentFetchProductQueryVariables,
      options?: UseQueryOptions<ContentFetchProductQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentFetchProductQuery, TError, TData>(
      ['contentFetchProduct', variables],
      fetcher<ContentFetchProductQuery, ContentFetchProductQueryVariables>(ContentFetchProductDocument, variables, headers, fetchOptions),
      options,
    );
useContentFetchProductQuery.document = ContentFetchProductDocument;


useContentFetchProductQuery.getKey = (variables: ContentFetchProductQueryVariables) => ['contentFetchProduct', variables];
;


useContentFetchProductQuery.rootKey = 'contentFetchProduct';

export const useInfiniteContentFetchProductQuery = <
      TData = ContentFetchProductQuery,
      TError = unknown
    >(
      variables: ContentFetchProductQueryVariables,
      options?: UseInfiniteQueryOptions<ContentFetchProductQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentFetchProductQuery, TError, TData>(
      ['contentFetchProduct.infinite', variables],
      (metaData) => fetcher<ContentFetchProductQuery, ContentFetchProductQueryVariables>(ContentFetchProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentFetchProductQuery.getKey = (variables: ContentFetchProductQueryVariables) => ['contentFetchProduct.infinite', variables];
;


useInfiniteContentFetchProductQuery.rootKey = 'contentFetchProduct.infinite';

useContentFetchProductQuery.fetcher = (variables: ContentFetchProductQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentFetchProductQuery, ContentFetchProductQueryVariables>(ContentFetchProductDocument, variables, headers, fetchOptions);
export const ContentProductIncreaseViewCountDocument = /*#__PURE__*/ `
    query contentProductIncreaseViewCount($id: ID!, $locale: ContentLanguage!, $increaseViewCount: Boolean = false) {
  contentProduct(
    id: $id
    language: $locale
    increaseViewCount: $increaseViewCount
  ) {
    id
  }
}
    `;
export const useContentProductIncreaseViewCountQuery = <
      TData = ContentProductIncreaseViewCountQuery,
      TError = unknown
    >(
      variables: ContentProductIncreaseViewCountQueryVariables,
      options?: UseQueryOptions<ContentProductIncreaseViewCountQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentProductIncreaseViewCountQuery, TError, TData>(
      ['contentProductIncreaseViewCount', variables],
      fetcher<ContentProductIncreaseViewCountQuery, ContentProductIncreaseViewCountQueryVariables>(ContentProductIncreaseViewCountDocument, variables, headers, fetchOptions),
      options,
    );
useContentProductIncreaseViewCountQuery.document = ContentProductIncreaseViewCountDocument;


useContentProductIncreaseViewCountQuery.getKey = (variables: ContentProductIncreaseViewCountQueryVariables) => ['contentProductIncreaseViewCount', variables];
;


useContentProductIncreaseViewCountQuery.rootKey = 'contentProductIncreaseViewCount';

export const useInfiniteContentProductIncreaseViewCountQuery = <
      TData = ContentProductIncreaseViewCountQuery,
      TError = unknown
    >(
      variables: ContentProductIncreaseViewCountQueryVariables,
      options?: UseInfiniteQueryOptions<ContentProductIncreaseViewCountQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentProductIncreaseViewCountQuery, TError, TData>(
      ['contentProductIncreaseViewCount.infinite', variables],
      (metaData) => fetcher<ContentProductIncreaseViewCountQuery, ContentProductIncreaseViewCountQueryVariables>(ContentProductIncreaseViewCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentProductIncreaseViewCountQuery.getKey = (variables: ContentProductIncreaseViewCountQueryVariables) => ['contentProductIncreaseViewCount.infinite', variables];
;


useInfiniteContentProductIncreaseViewCountQuery.rootKey = 'contentProductIncreaseViewCount.infinite';

useContentProductIncreaseViewCountQuery.fetcher = (variables: ContentProductIncreaseViewCountQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentProductIncreaseViewCountQuery, ContentProductIncreaseViewCountQueryVariables>(ContentProductIncreaseViewCountDocument, variables, headers, fetchOptions);
export const ContentFetchLicenseDocument = /*#__PURE__*/ `
    query contentFetchLicense($input: ContentFetchLicenseInput!) {
  contentFetchLicense(input: $input) {
    key
  }
}
    `;
export const useContentFetchLicenseQuery = <
      TData = ContentFetchLicenseQuery,
      TError = unknown
    >(
      variables: ContentFetchLicenseQueryVariables,
      options?: UseQueryOptions<ContentFetchLicenseQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentFetchLicenseQuery, TError, TData>(
      ['contentFetchLicense', variables],
      fetcher<ContentFetchLicenseQuery, ContentFetchLicenseQueryVariables>(ContentFetchLicenseDocument, variables, headers, fetchOptions),
      options,
    );
useContentFetchLicenseQuery.document = ContentFetchLicenseDocument;


useContentFetchLicenseQuery.getKey = (variables: ContentFetchLicenseQueryVariables) => ['contentFetchLicense', variables];
;


useContentFetchLicenseQuery.rootKey = 'contentFetchLicense';

export const useInfiniteContentFetchLicenseQuery = <
      TData = ContentFetchLicenseQuery,
      TError = unknown
    >(
      variables: ContentFetchLicenseQueryVariables,
      options?: UseInfiniteQueryOptions<ContentFetchLicenseQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentFetchLicenseQuery, TError, TData>(
      ['contentFetchLicense.infinite', variables],
      (metaData) => fetcher<ContentFetchLicenseQuery, ContentFetchLicenseQueryVariables>(ContentFetchLicenseDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentFetchLicenseQuery.getKey = (variables: ContentFetchLicenseQueryVariables) => ['contentFetchLicense.infinite', variables];
;


useInfiniteContentFetchLicenseQuery.rootKey = 'contentFetchLicense.infinite';

useContentFetchLicenseQuery.fetcher = (variables: ContentFetchLicenseQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentFetchLicenseQuery, ContentFetchLicenseQueryVariables>(ContentFetchLicenseDocument, variables, headers, fetchOptions);
export const ContentFetchReviewsDocument = /*#__PURE__*/ `
    query contentFetchReviews($input: ContentProductReviewsInput!) {
  contentProductReviews(input: $input) {
    rating {
      average
      count
      groups {
        rating
        count
      }
    }
    cursor
    reviews {
      id
      parentId
      userId
      rating
      body
      createdAt
      user {
        id
        firstName
        lastName
        avatarUrl
        profileUrls {
          crafter
        }
      }
    }
  }
}
    `;
export const useContentFetchReviewsQuery = <
      TData = ContentFetchReviewsQuery,
      TError = unknown
    >(
      variables: ContentFetchReviewsQueryVariables,
      options?: UseQueryOptions<ContentFetchReviewsQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentFetchReviewsQuery, TError, TData>(
      ['contentFetchReviews', variables],
      fetcher<ContentFetchReviewsQuery, ContentFetchReviewsQueryVariables>(ContentFetchReviewsDocument, variables, headers, fetchOptions),
      options,
    );
useContentFetchReviewsQuery.document = ContentFetchReviewsDocument;


useContentFetchReviewsQuery.getKey = (variables: ContentFetchReviewsQueryVariables) => ['contentFetchReviews', variables];
;


useContentFetchReviewsQuery.rootKey = 'contentFetchReviews';

export const useInfiniteContentFetchReviewsQuery = <
      TData = ContentFetchReviewsQuery,
      TError = unknown
    >(
      variables: ContentFetchReviewsQueryVariables,
      options?: UseInfiniteQueryOptions<ContentFetchReviewsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentFetchReviewsQuery, TError, TData>(
      ['contentFetchReviews.infinite', variables],
      (metaData) => fetcher<ContentFetchReviewsQuery, ContentFetchReviewsQueryVariables>(ContentFetchReviewsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentFetchReviewsQuery.getKey = (variables: ContentFetchReviewsQueryVariables) => ['contentFetchReviews.infinite', variables];
;


useInfiniteContentFetchReviewsQuery.rootKey = 'contentFetchReviews.infinite';

useContentFetchReviewsQuery.fetcher = (variables: ContentFetchReviewsQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentFetchReviewsQuery, ContentFetchReviewsQueryVariables>(ContentFetchReviewsDocument, variables, headers, fetchOptions);
export const ContentCreateReviewDocument = /*#__PURE__*/ `
    mutation ContentCreateReview($productId: String!, $parentId: String, $rating: Int, $body: String!, $getInTouch: Boolean) {
  contentCreateReview(
    input: {productId: $productId, parentId: $parentId, rating: $rating, body: $body, getInTouch: $getInTouch}
  )
}
    `;
export const useContentCreateReviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ContentCreateReviewMutation, TError, ContentCreateReviewMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) =>
    useMutation<ContentCreateReviewMutation, TError, ContentCreateReviewMutationVariables, TContext>(
      ['ContentCreateReview'],
      (variables?: ContentCreateReviewMutationVariables) => fetcher<ContentCreateReviewMutation, ContentCreateReviewMutationVariables>(ContentCreateReviewDocument, variables, headers, fetchOptions)(),
      options
    );
useContentCreateReviewMutation.getKey = () => ['ContentCreateReview'];

useContentCreateReviewMutation.fetcher = (variables: ContentCreateReviewMutationVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentCreateReviewMutation, ContentCreateReviewMutationVariables>(ContentCreateReviewDocument, variables, headers, fetchOptions);
export const ContentEditReviewDocument = /*#__PURE__*/ `
    mutation ContentEditReview($reviewId: ID!, $rating: Int, $body: String!) {
  contentEditReview(input: {id: $reviewId, rating: $rating, body: $body})
}
    `;
export const useContentEditReviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ContentEditReviewMutation, TError, ContentEditReviewMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) =>
    useMutation<ContentEditReviewMutation, TError, ContentEditReviewMutationVariables, TContext>(
      ['ContentEditReview'],
      (variables?: ContentEditReviewMutationVariables) => fetcher<ContentEditReviewMutation, ContentEditReviewMutationVariables>(ContentEditReviewDocument, variables, headers, fetchOptions)(),
      options
    );
useContentEditReviewMutation.getKey = () => ['ContentEditReview'];

useContentEditReviewMutation.fetcher = (variables: ContentEditReviewMutationVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentEditReviewMutation, ContentEditReviewMutationVariables>(ContentEditReviewDocument, variables, headers, fetchOptions);
export const ContentMyReviewDocument = /*#__PURE__*/ `
    query ContentMyReview($productId: ID!) {
  contentMyReview(productId: $productId) {
    id
    rating
    body
    createdAt
  }
}
    `;
export const useContentMyReviewQuery = <
      TData = ContentMyReviewQuery,
      TError = unknown
    >(
      variables: ContentMyReviewQueryVariables,
      options?: UseQueryOptions<ContentMyReviewQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentMyReviewQuery, TError, TData>(
      ['ContentMyReview', variables],
      fetcher<ContentMyReviewQuery, ContentMyReviewQueryVariables>(ContentMyReviewDocument, variables, headers, fetchOptions),
      options,
    );
useContentMyReviewQuery.document = ContentMyReviewDocument;


useContentMyReviewQuery.getKey = (variables: ContentMyReviewQueryVariables) => ['ContentMyReview', variables];
;


useContentMyReviewQuery.rootKey = 'ContentMyReview';

export const useInfiniteContentMyReviewQuery = <
      TData = ContentMyReviewQuery,
      TError = unknown
    >(
      variables: ContentMyReviewQueryVariables,
      options?: UseInfiniteQueryOptions<ContentMyReviewQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentMyReviewQuery, TError, TData>(
      ['ContentMyReview.infinite', variables],
      (metaData) => fetcher<ContentMyReviewQuery, ContentMyReviewQueryVariables>(ContentMyReviewDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentMyReviewQuery.getKey = (variables: ContentMyReviewQueryVariables) => ['ContentMyReview.infinite', variables];
;


useInfiniteContentMyReviewQuery.rootKey = 'ContentMyReview.infinite';

useContentMyReviewQuery.fetcher = (variables: ContentMyReviewQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentMyReviewQuery, ContentMyReviewQueryVariables>(ContentMyReviewDocument, variables, headers, fetchOptions);
export const ContentProductStatsDocument = /*#__PURE__*/ `
    query ContentProductStats($productId: ID!) {
  contentProductStats(id: $productId) {
    downloads
    views
    favorites
  }
}
    `;
export const useContentProductStatsQuery = <
      TData = ContentProductStatsQuery,
      TError = unknown
    >(
      variables: ContentProductStatsQueryVariables,
      options?: UseQueryOptions<ContentProductStatsQuery, TError, TData>,
      headers?: Headers,
      fetchOptions?: FetchOptions
    ) =>
    useQuery<ContentProductStatsQuery, TError, TData>(
      ['ContentProductStats', variables],
      fetcher<ContentProductStatsQuery, ContentProductStatsQueryVariables>(ContentProductStatsDocument, variables, headers, fetchOptions),
      options,
    );
useContentProductStatsQuery.document = ContentProductStatsDocument;


useContentProductStatsQuery.getKey = (variables: ContentProductStatsQueryVariables) => ['ContentProductStats', variables];
;


useContentProductStatsQuery.rootKey = 'ContentProductStats';

export const useInfiniteContentProductStatsQuery = <
      TData = ContentProductStatsQuery,
      TError = unknown
    >(
      variables: ContentProductStatsQueryVariables,
      options?: UseInfiniteQueryOptions<ContentProductStatsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ContentProductStatsQuery, TError, TData>(
      ['ContentProductStats.infinite', variables],
      (metaData) => fetcher<ContentProductStatsQuery, ContentProductStatsQueryVariables>(ContentProductStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteContentProductStatsQuery.getKey = (variables: ContentProductStatsQueryVariables) => ['ContentProductStats.infinite', variables];
;


useInfiniteContentProductStatsQuery.rootKey = 'ContentProductStats.infinite';

useContentProductStatsQuery.fetcher = (variables: ContentProductStatsQueryVariables, headers?: Headers, fetchOptions?: FetchOptions) => fetcher<ContentProductStatsQuery, ContentProductStatsQueryVariables>(ContentProductStatsDocument, variables, headers, fetchOptions);